import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./CareerTrainingSection.css";

const programs = [
  {
    title: "Data Engineering",
    img: "/assets/images/pst_it_solution/AlumniPlaced/icon-1.png",
  },
  {
    title: "Data Analytics",
    img: "/assets/images/pst_it_solution/AlumniPlaced/icon-2.png",
  },
  {
    title: "Big Data & PySpark",
    img: "/assets/images/pst_it_solution/AlumniPlaced/icon-3.png",
  },
  {
    title: "Cloud (AWS & Azure)",
    img: "/assets/images/pst_it_solution/AlumniPlaced/icon-4.png",
  },
  {
    title: "SQL, Python & ETL",
    img: "/assets/images/pst_it_solution/AlumniPlaced/icon-5.png",
  },
  {
    title: "Real-Time Data Pipelines",
    img: "/assets/images/pst_it_solution/AlumniPlaced/icon-6.png",
  },
];

const CareerTrainingSection = () => {
  return (
    <section className="career-training-section">
      <Container>
        {/* Heading */}
        <Row className="text-center mb-5">
          <Col>
            <h2 className="section-title">
              Career Focused <span>Training Programs</span>
            </h2>
          </Col>
        </Row>

        {/* Programs Row */}
        <Row className="justify-content-center align-items-start program-row">
          {programs.map((item, index) => (
            <Col
              key={index}
              xs={6}
              sm={4}
              md={4}
              lg={2}
              className="text-center program-col"
            >
              <div className="program-item">
                <div className="icon-wrapper">
                  <img src={item.img} alt="not load" className="step_img" />
                </div>
                <p className="program-title">{item.title}</p>
              </div>
            </Col>
          ))}
        </Row>

        {/* Description */}
        <Row className="">
          <Col className="text-center">
            <p className="section-description">
              Our curriculum is designed by working professionals and focuses on
              real-world implementation rather than just theory.
            </p>
          </Col>
        </Row>
      </Container>
<div className="cards_content_holder">

      {/*section 1*/}
      <Container>
        <Row className="align-items-center card-row mt-4">
          {/* Text */}
          <Col lg={6} md={6} className="mb-4 mb-md-0">
            <h3 className="section-heading">
              Hands-On Learning & <br /> Real Projects
            </h3>
            <p className="section-text">
              Learners gain practical experience through real-time projects,
              live coding, data pipeline building, and modern architectures like
              Lakehouse and Medallion. This ensures strong execution skills and
              production-level confidence.
            </p>
          </Col>

          {/* Image */}
          <Col lg={6} md={6}>
            <div className="image-wrapper">
              <img
                src="/assets/images/pst_it_solution/carrer-training/img-1.png"
                alt="Hands-On Learning"
                className="img-fluid rounded-4"
              />
            </div>
          </Col>
        </Row>
      </Container>
      {/* ===== Section 2 ===== */}
      <div className="section-two">
        <Container>
          <Row className="align-items-center card-row second-row">
            {/* Image */}
            <Col lg={6} md={6} className="order-1 order-md-0 mb-4 mb-md-0">
              <div className="image-wrapper">
                <img
                  src="/assets/images/pst_it_solution/carrer-training/img-2.png"
                  alt="Industry Expert Mentorship"
                  className="img-fluid rounded-4"
                />
              </div>
            </Col>

            {/* Text */}
            <Col lg={6} md={6} className="order-0 order-md-1">
              <h3 className="section-heading">
                Industry Expert <br /> Mentorship
              </h3>
              <p className="section-text">
                Training is delivered by experienced professionals with 7–12+
                years of industry experience. Learners receive complete
                guidance, doubt-solving, and real-world insights directly from
                working experts.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* section 3*/}
      <Container>
        <Row className="align-items-center card-row ">
          {/* Text */}
          <Col lg={6} md={6} className="mb-4 mb-md-0">
            <h3 className="section-heading">
              IT Solutions & Industry <br /> Experience
            </h3>
            <p className="section-text">
              Along with training, we also work on real-world IT and data
              projects, which helps us design programs aligned with current
              industry standards, tools, and technologies.
            </p>
          </Col>

          {/* Image */}
          <Col lg={6} md={6}>
            <div className="image-wrapper">
              <img
                src="/assets/images/pst_it_solution/carrer-training/img-3.png"
                alt="Hands-On Learning"
                className="img-fluid rounded-4"
              />
            </div>
          </Col>
        </Row>
      </Container>
</div>
    </section>
  );
};

export default CareerTrainingSection;
